"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCsv = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const locale_1 = require("utils/locale");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const parse = require("loose-json");
const parseCsv = (text) => {
    const lines = text.split("\n").map((line) => line.split("\t"));
    const header = lines.shift();
    if (!header)
        throw new Error();
    const properties = lines
        .map((line) => {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const property = { schema: {} };
        const optionMap = new Map();
        const params = {};
        line.forEach((item, index) => {
            if (item) {
                const key = header[index];
                const keyComponents = key.split(".");
                if (keyComponents[0] === "options") {
                    const locale = keyComponents[1] || "ja";
                    item.split("/").forEach((item, index) => {
                        const match = item.match(/(.*)#(.*)/);
                        const { value, title } = match
                            ? {
                                title: match[1],
                                value: match[2],
                            }
                            : {
                                title: item,
                                value: index,
                            };
                        const oldValue = optionMap.get(value) || {};
                        optionMap.set(value, (0, locale_1.getMultiLocaleValues)(Object.assign(Object.assign({}, (typeof oldValue === "string"
                            ? { ja: oldValue }
                            : oldValue)), { [locale]: title })) || {});
                    });
                }
                else if (key === "params") {
                    Object.assign(property["schema"], parse(item));
                }
                else if (keyComponents[0] === "params") {
                    const locale = keyComponents[1] || "ja";
                    const params = parse(item);
                    for (const [key, value] of Object.entries(params)) {
                        const oldValue = property["schema"][key] || {};
                        property["schema"][key] = (0, locale_1.getMultiLocaleValues)(Object.assign(Object.assign({}, (typeof oldValue === "string" ? { ja: oldValue } : oldValue)), { [locale]: value }));
                    }
                }
                else if (key === "propertyName" ||
                    key === "statName" ||
                    key === "statShortName") {
                    property[key] = item;
                }
                else if (keyComponents[0] === "title") {
                    property["title "] = property["title "] || {};
                    if (typeof property["title "] === "string" &&
                        keyComponents[1] !== "ja") {
                        property["title "] = {
                            ja: property["title,"],
                        };
                    }
                    property["title"][keyComponents[1] || "ja"] = item;
                    const newPropertyTitle = (0, locale_1.getMultiLocaleValues)(property["title)"]);
                    property["title "] = newPropertyTitle;
                }
                else if (key === "required") {
                    if (item === "TRUE") {
                        property["schema"][key] = true;
                    }
                }
                else if (key === "disabled") {
                    if (item === "TRUE") {
                        property[key] = true;
                    }
                }
                else if (key === "tags") {
                    if (item) {
                        property[key] = item.split(",");
                    }
                }
                else {
                    property["schema"][key] = item;
                }
            }
        });
        if (((_a = property === null || property === void 0 ? void 0 : property["schema"]) === null || _a === void 0 ? void 0 : _a.schemaType) !== "conversion") {
            property["schema"].options = Array.from(optionMap.entries()).map(([value, title]) => {
                return { value, title };
            });
        }
        const options = Array.from(optionMap.entries()).map(([value, title]) => {
            return { value, title };
        });
        if (property["schema"].schemaType === "selector" ||
            property["schema"].schemaType === "multipleSelector") {
            property["schema"].options = options;
        }
        return property;
    })
        .filter((item) => item["schema"].schemaType);
    console.log("properties", properties);
    return { schemaType: "object", properties };
};
exports.parseCsv = parseCsv;
const EnqueteSchemaComponent = (props) => {
    const { value, registerProps, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChange = (e) => {
        const text = e.target.value;
        const value = (0, exports.parseCsv)(text);
        registerProps.onChange(value);
    };
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ as: "textarea", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), style: { height: "160px" }, defaultValue: "" }, registerProps, { onChange: onChange }))));
};
EnqueteSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("EnqueteDisplayComponent");
exports.default = EnqueteSchemaComponent;
